// store/modules/snapshots.js
const state = {
  ladders: [],
  // will hold the most recently fetched detail-rows
  ladderEntries: [],
  error: 0
}

// getters
const getters = {
  ladders: state => state.ladders,
  // expose the array of detail-rows
  ladderEntries: state => state.ladderEntries
}

// actions
const actions = {
  // called by socket event "getSavedLadders"
  getSavedLadders ({ commit }, payload) {
    commit('setLadders', payload)
  },
  // called by socket event "getSavedLaddersEntries"
  getSavedLaddersEntries ({ commit }, payload) {
    commit('setLadderEntries', payload)
  },
  setError ({ commit }, payload) {
    commit('setError', payload.data)
  }
}

// mutations
const mutations = {
  setLadders (state, all) {
    // payload shape: all.data.data is the array of saved-ladder summaries
    state.ladders = all.data.data
  },
  setLadderEntries (state, all) {
    // payload shape: all.data.data is the array of entries for one ladder
    state.ladderEntries = all.data.data
  },
  setError (state, error) {
    state.error = { error, time: Date.now() }
  }
}

export default {
  // (add `namespaced: true` if you want to namespace it)
  state,
  getters,
  actions,
  mutations
}
